import {
  Maybe,
  Strapi_FooterEntity,
  Strapi_FooterPrivacyLinkEntity,
  Strapi_NavbarEntity,
  Strapi_SeoEntityResponse,
} from '@types'
import { GatsbyBrowser } from 'gatsby'
import React from 'react'
import DefaultLayout from 'src/layouts/DefaultLayout'
import { TUniqTitle } from 'src/types'

export const wrapPageElement: GatsbyBrowser<any, DefaultPageProps>['wrapPageElement'] = ({ element, props }) => {
  return <DefaultLayout {...props}>{element as any}</DefaultLayout>
}

export interface DefaultPageProps {
  data?: any
  seo: Maybe<Strapi_SeoEntityResponse> | undefined
  navbar: Strapi_NavbarEntity[] | undefined
  privacyLinks: Array<Strapi_FooterPrivacyLinkEntity>
  footers: Array<Strapi_FooterEntity>
  footerWarning?: { attributes: { JSON: IFooterWarning } }
  general?: { attributes: { JSON: { [key: string]: string } } }
  uniqTitle?: TUniqTitle
  pageLocales?: string[]
  dropdowns?: any
}

export interface IFooterWarning {
  title: string
  description: string
}
